const Footer = () => {
    return (
      <footer
        className="text-center text-lg-start text-white"
        style={{ backgroundColor: '#1c2331' }}
      >
        {/* Upper Section */}
        <div className="container p-4">
          <div className="row">
            {/* About Section */}
            <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
              <h5 className="text-uppercase">About Us</h5>
              <p>
                BlinkURL is the leading URL shortener service providing fast and
                reliable links for all your needs. Join us to simplify your
                sharing!
              </p>
            </div>
  
            {/* Quick Links */}
            <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
              <h5 className="text-uppercase">Quick Links</h5>
              <ul className="list-unstyled mb-0">
                <li>
                  <a href="/about" className="text-white">
                    About
                  </a>
                </li>
                <li>
                  <a href="/features" className="text-white">
                    Features
                  </a>
                </li>
                <li>
                  <a href="/pricing" className="text-white">
                    Pricing
                  </a>
                </li>
                <li>
                  <a href="/support" className="text-white">
                    Support
                  </a>
                </li>
              </ul>
            </div>
  
            {/* Social Media */}
            <div className="col-lg-2 col-md-3 mb-4 mb-md-0">
              <h5 className="text-uppercase">Follow Us</h5>
              <ul className="list-unstyled d-flex justify-content-start">
                <li className="me-3">
                  <a
                    href="https://www.facebook.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    <i className="fab fa-facebook"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a
                    href="https://www.twitter.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a
                    href="https://www.instagram.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
                <li className="me-3">
                  <a
                    href="https://www.linkedin.com"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-white"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
  
            {/* Subscription Form */}
            <div className="col-lg-4 col-md-6 mb-4 mb-md-0">
              <h5 className="text-uppercase">Subscribe</h5>
              <form>
                <div className="form-outline form-white mb-4">
                  <input
                    type="email"
                    id="form5Example2"
                    className="form-control"
                    placeholder="Enter your email"
                  />
                </div>
                <button type="submit" className="btn btn-outline-light btn-rounded">
                  Subscribe
                </button>
              </form>
            </div>
          </div>
        </div>
  
        {/* Lower Section */}
        <div
          className="text-center p-3"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}
        >
          <span>© 2025 BlinkURL </span>
          <a className="text-white" href="/terms">
            Terms
          </a>{' '}
          |{' '}
          <a className="text-white" href="/privacy">
            Privacy
          </a>
        </div>
      </footer>
    );
  };
  
  export default Footer;
  